// extracted by mini-css-extract-plugin
module.exports = {"container":"BSMSearchItem_container__2j8NN","addBtn":"BSMSearchItem_addBtn__13l3j"};